(function ($, generic) {
    Drupal.behaviors.sdRenutrivVtoV1 = {
      attach: function (context) {
        var self = this;
        var $sppContainer = $('.js-spp-content', context);
        var productID = $sppContainer.attr('data-product-id');
        var jsonRpcParams = {};
        var setRenutrivValue;

        if (self.attached) {
          return;
        }
        self.attached = true;

        jsonRpcParams.products = ['PROD' + productID];
        generic.jsonrpc.fetch({
          method: 'prodcat',
          params: [jsonRpcParams],
          onSuccess: function (jsonRpcResponse) {
            setRenutrivValue(jsonRpcResponse);
          }
        });

        setRenutrivValue = function (jsonRpcResponse) {
          var jsonRpcValue = jsonRpcResponse?.getValue();
          var isRenutriv = jsonRpcValue?.products[0]?.skus?.some(item => {return item.RENUTRIV_PRODUCT_FLAG === 1});

          if (isRenutriv) {
            $('body').addClass('renutriv-product');
            $sppContainer.attr({
              'data-disable-survey': 'true',
              'data-style-color': 'black',
              'data-enable-four-way-looks': 'true'
            });
            if (navigator?.userAgentData?.platform === 'Windows') {
              $('body').addClass('rn-vto-cta');
            }
          }
        };
      }
    };
  })(jQuery, window.generic || {});
